import { render, staticRenderFns } from "./SpecialistLegend.vue?vue&type=template&id=4f1b2390&scoped=true"
import script from "./SpecialistLegend.vue?vue&type=script&lang=js"
export * from "./SpecialistLegend.vue?vue&type=script&lang=js"
import style0 from "./SpecialistLegend.vue?vue&type=style&index=0&id=4f1b2390&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b2390",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1b2390')) {
      api.createRecord('4f1b2390', component.options)
    } else {
      api.reload('4f1b2390', component.options)
    }
    module.hot.accept("./SpecialistLegend.vue?vue&type=template&id=4f1b2390&scoped=true", function () {
      api.rerender('4f1b2390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialist-availability-calendar/components/SpecialistLegend.vue"
export default component.exports